import React, { memo } from 'react';
import styled from 'styled-components';
import Tooltip from '@mui/material/Tooltip';

const Bubble = styled.div`
  height: 32px;
  min-width: 32px;
  border-radius: 16px;
  font-size: 16px;
  text-align: center;
  line-height: 32px;
`;

const YellowBubble = styled(Bubble)`
  background-color: #FBE2B8;
  color: #5E4404;
`;

const RedBubble = styled(Bubble)`
  background-color: #FCD6D8;
  color: #AF0000;
`;

const GrayBubble = styled(Bubble)`
background-color: #EAF0F6;
color: #99ACC2;
`;

const Tasks = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: #595959;
`;

export default memo(function SummaryBar({ values }) {
  const { due = 0, overdue = 0 } = values?.[0]?.taskDistribution ?? {};

  return (<>
    <Tasks>Tasks due:&nbsp;</Tasks>
    {due ? <Tooltip title="Tasks due"><YellowBubble>{due}</YellowBubble></Tooltip> : null}
    {overdue ? <Tooltip title="Tasks overdue" ><RedBubble>{overdue}</RedBubble></Tooltip> : null}
    {!(due || overdue) && <Tooltip title="No tasks"><GrayBubble>0</GrayBubble></Tooltip>}
  </>);
});
